export const API_URL               = process.env.REACT_APP_API_URL;
export const CP_PUBLIC_ID          = process.env.REACT_APP_CP_PUBLIC_ID;

export const VK_OAUTH_BASE_URL     = 'https://id.vk.com';
export const VK_AUTHORIZE_URL      = `${VK_OAUTH_BASE_URL}/authorize`;
export const VK_CLIENT_ID          = process.env.REACT_APP_VK_CLIENT_ID;
export const VK_CLIENT_SECRET      = process.env.REACT_APP_VK_CLIENT_SECRET; // только для бэка
export const VK_REDIRECT_URI       = process.env.REACT_APP_VK_REDIRECT_URI;
export const VK_SCOPE              = 'vkid.personal_info email';

export const VK_TOKEN_ENDPOINT     = `${VK_OAUTH_BASE_URL}/token`;
export const VK_USERINFO_ENDPOINT  = `${VK_OAUTH_BASE_URL}/api/v1/userinfo`;
